import React from 'react';

export const UpdatePayment = ({
        isOpen,
        onClose,
        totalSum,
        onPaymentMethod,
        payment,
    }) => {
    if (!isOpen) return null;

    if (payment && payment !== 'none') return (
        <div className="modal fade show" style={{
            display: 'block',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1050
        }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: '8px' }}>
                    <div className="modal-header border-0 pb-0">
                        <h4 className="modal-title w-100 text-center" style={{ fontSize: '1.5rem' }}>
                            Возврат оплаты
                        </h4>
                    </div>

                    <div className="modal-body text-center py-4">
                        <p className="h5 mb-0" style={{ lineHeight: '1.5' }}>
                            Будет произведена операция возврата в кассу<br />
                            на сумму <strong>{totalSum} руб.</strong>
                        </p>
                    </div>

                    <div className="modal-footer border-0 justify-content-center">
                        <div className="d-flex" style={{ width: 'fit-content', gap: '1rem' }}>
                            <button
                                className="btn btn-outline-secondary px-4"
                                onClick={onClose}
                                style={{ minWidth: '100px' }}
                            >
                                Отмена
                            </button>
                            <button
                                className="btn btn-primary px-4"
                                onClick={() => onPaymentMethod(payment, true)}
                                style={{ minWidth: '100px' }}
                            >
                                Возврат
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="modal fade show" style={{
            display: 'block',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1050
        }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: '8px' }}>
                    <div className="modal-header border-0 pb-0">
                        <h4 className="modal-title w-100 text-center" style={{ fontSize: '1.5rem' }}>
                            Оплата накладной
                        </h4>
                    </div>

                    <div className="modal-body text-center py-4">
                        <p className="h5 mb-0" style={{ lineHeight: '1.5' }}>
                            Будет произведена операция списания из кассы<br />
                            на сумму <strong>{totalSum} руб.</strong>
                        </p>
                    </div>

                    <div className="modal-footer border-0 justify-content-center">
                        <div className="d-flex" style={{ width: 'fit-content', gap: '1rem' }}>
                            <button
                                className="btn btn-outline-secondary px-4"
                                onClick={onClose}
                                style={{ minWidth: '100px' }}
                            >
                                Отмена
                            </button>
                            <button
                                className="btn btn-primary px-4"
                                onClick={() => onPaymentMethod('cash')}
                                style={{ minWidth: '100px' }}
                            >
                                Наличные
                            </button>
                            <button
                                className="btn btn-primary px-4"
                                onClick={() => onPaymentMethod('noncash')}
                                style={{ minWidth: '100px' }}
                            >
                                Безналичные
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};